var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.postion ? "positionA":""],style:({right:_vm.right+"px",bottom:_vm.bottom+"px"})},[_c('el-link',{staticStyle:{"width":"10px","height":"10px"},attrs:{"underline":false,"icon":"el-icon-document-copy"},on:{"click":_vm.copy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }